import dayjs from 'dayjs'
import { i18n } from '@/i18n/information'

/**
 * 格式化资讯发布时间（本地时区）
 * 规则：
 * 1) 1小时内：返回“xx分钟前”（取整到分钟，不四舍五入；差值为负则不进入该分支）
 * 2) 当天且超过1小时：返回“HH:mm”（24小时制，双位数）
 * 3) 当年但跨日：返回“MM/DD HH:mm”（双位数）
 * 4) 跨年：返回“YYYY/MM/DD HH:mm”（年份4位，其他双位数）
 * 性能：仅在调用处计算一次，避免在渲染期间重复计算
 * @param {number} epochSeconds - 目标时间（秒）
 * @param {import('dayjs').Dayjs} [now] - 当前时间（可选，用于测试）
 * @returns {string}
 */
export function formatPublishTime(epochSeconds, now = dayjs()) {
  const target = dayjs(epochSeconds * 1000)

  // 仅在目标时间不晚于当前时间时使用“xx分钟前”
  const diffMinutes = now.diff(target, 'minute')
  if (diffMinutes >= 0 && diffMinutes < 60) {
    const displayMinutes = diffMinutes === 0 ? 1 : diffMinutes
    return i18n.t('minutesAgo', { n: displayMinutes })
  }

  // 同一天但超过1小时
  if (now.isSame(target, 'day')) {
    return target.format('HH:mm')
  }

  // 同一年但跨日
  if (now.isSame(target, 'year')) {
    return target.format('MM/DD HH:mm')
  }

  // 跨年
  return target.format('YYYY/MM/DD HH:mm')
}
